// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__oNf8l","message":"styles_message__kZb63","btnContainer":"styles_btnContainer__qHJmo"};